import { gql } from '@apollo/client';
export const getScheduledTimeOffs = gql`
  query scheduledTimeOffFranchise($input: ScheduledTimeOffSearchInput) {
    scheduledTimeOffFranchise(input: $input) {
     franchiseId
     franchise{
      id
      name
      scheduledTimeOffCategories {
        id
        name
        isPaid
      }
      contactEmail
      contactPhone
      coachPortalPhone
      settings{
        canManageTimeOff
        timeOffNotice
        coachReplyToAddress
        canAddTimeOff
      }
     }
     timeOffs { 
      id
      startDate
      endDate
      startTime
      endTime
      resourceId
      status
      categoryId
      created
      dateTimes {
        id
        date
        startTime
        endTime
      }
      franchiseId
      conflicts {
          id
          startDateTimeInUTC
          startTime
          endTime
          endDateTimeInUTC
          staffAssignments
          event {
            id
    code
    effectiveName
    label
    status
    registrationStatus
    coachName
    ageRange
    ageFrom
    registrationStatus
    ageRangeLabel
    ageTo
    ageRestriction
    ageFromConstraint
    ageFromConstraintCustomDate
    ageToConstraint
    ageToConstraintCustomDate
    ageToMonths
    ageFromMonths
    soldOut
    effectiveSoldOut
    isBundle
    soldOutRegistrations
    activeEnrollments
    effectiveActiveEnrollments
    allowWaitlist
    capacity
    availableCapacity
    length
    logoUrl
    startTime
    endTime
    registrationStartDate
    registrationEndDate
    annualFee
    registrationFee
    monthlyFee
    isMonthlyDisplayAmountOverride
    monthlyFeeLabel
    showNumberSessionOnSearch
    overriddenNumberOfSessionText
    isNumberOfSessionOverride

    sessionTypeText
    hideTotalClassesCount
    upfrontFee
    perClassFee
    isPaymentRequired
    paymentOptions
    isTimesOverride
    duration
    time
    recurring
    weekdays
    isDaysOfTheWeekOverride

    isDatesOverride
    datesOverrideText
    dateLabel
    timeLabel
    startDate
    endDate
    chargeDay
    feeSchedule
    registrationFormFields
            location {
              id
              name
              city
              state
              zipcode
              address
            }
            franchise{
              id
              name 
              
            }
            program {
              id
              name
              color
            }
          }
        }
     }
    }
  }
`;
